(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const q = selector => root.querySelector(selector);
    const like = q('[data-love-like]'), dislike = q('[data-love-dislike]');
    const helper = q('[data-love-helper]'), thanks = q('[data-love-thanks]');
    const choices = q('[data-love-choices]'), status = q('[data-love-status]'), reset = q('[data-love-reset]');
    const speech = q('[data-love-speech]');
    const helperSpeech = q('.amuru-love-helper-bubble'), tap = q('.amuru-love-tap');
    const lines = {
      welcome: ['即答してくれるの、すき♡', 'やった！ あむるもうれしい♡', 'その「好き」、待ってた♡', '迷わず押してくれてありがと♡', 'あむると気が合うね♡'],
      finale: ['だいすき、ありがとう♡', 'いっしょに応援しようね♡', 'うれしくて跳んじゃった♡', 'その「好き」、受け取ったよ♡', 'みんなで、せーのっ♡'],
      arriving: ['押すの、こっちだよね？', 'あれ？ 押し間違えたかな？', 'じーっ。ほんとにそっち？', '好きボタン、こっちだよ♡', 'もう一回よく見てみよ？'],
      moving: ['あむるが押しちゃう♡', 'あむるが代わりに押すね♡', 'ここはあむるに任せて♡', 'その「好き」、お手伝い♡', 'はーい、こっちをぽちっ♡'],
      tap: ['ぽちっ♡', 'えいっ♡', 'よいしょ♡', 'ぽんっ♡', 'えへへ♡'],
      claim: ['はい、好きいただきました♡', 'これでおそろいの「好き」♡', 'あむると一緒に応援決定♡', '好きってことで、いいよね♡', 'ようこそ、好きのほうへ♡'],
      red: ['異議なし！', '賛成っ！', '好きに一票！', '応援するぞ！', 'その調子！'],
      white: ['だいすき！', 'いっしょに♡', 'やったね♡', '好きだよ♡', '応援しよ♡'],
      tease: ['最初から素直に押せばいいのに♡', 'ほら、好きになったでしょ？♡', '次は自分で押してね♡', '照れなくてもいいんだよ♡', 'あむるにはお見通しだよ♡']
    };
    // Shuffle each scene's five lines; use all five before starting a new bag.
    const bags = {}, previous = {};
    const pick = key => {
      if (!bags[key]?.length) {
        const bag = [...lines[key]];
        for (let i = bag.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [bag[i], bag[j]] = [bag[j], bag[i]];
        }
        if (bag[0] === previous[key]) [bag[0], bag[1]] = [bag[1], bag[0]];
        bags[key] = bag;
      }
      return previous[key] = bags[key].shift();
    };
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    // Only these Amuru originals vary. The singer and three party mascots stay fixed.
    const art = JSON.parse(q('[data-love-art]').textContent);
    const stageArt = q('.amuru-love-stage-wink'), helperArt = q('.amuru-love-helper img'), thanksArt = q('.amuru-love-thanks > img');
    const artLast = {}, artLoads = new Map(), artRequests = new Map();
    let artPlan, artRound = 0;
    const chooseArt = (key, pool, excluded = []) => {
      const candidates = pool.filter(url => url !== artLast[key] && !excluded.includes(url));
      return artLast[key] = candidates[Math.floor(Math.random() * candidates.length)];
    };
    const loadArt = url => {
      if (!artLoads.has(url)) artLoads.set(url, new Promise(resolve => {
        const image = new Image();
        image.onload = () => resolve(true); image.onerror = () => resolve(false);
        image.src = url;
      }));
      return artLoads.get(url);
    };
    const showArt = (element, url) => {
      const round = artRound;
      artRequests.set(element, url);
      // Keep the current original visible while the next original loads.
      loadArt(url).then(loaded => {
        if (loaded && round === artRound && artRequests.get(element) === url) element.src = url;
      });
    };
    const prepareArt = () => {
      artRound++;
      const welcome = chooseArt('welcome', art.happy);
      const finale = chooseArt('finale', art.happy, [welcome]);
      artPlan = {
        helper: chooseArt('helper', art.pressure), welcome, finale,
        thanks: chooseArt('thanks', art.happy, [welcome, finale])
      };
    };
    const warmArt = () => Object.values(artPlan).forEach(loadArt);
    prepareArt();
    // Fetch only this round's selected originals when the banner approaches the viewport.
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { warmArt(); observer.disconnect(); }
      }, {rootMargin:'500px'});
      observer.observe(root);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
    }
    root.addEventListener('pointerenter', warmArt, {once:true});
    root.addEventListener('focusin', warmArt, {once:true});
    const timers = new Set();
    const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); fn(); }, ms); timers.add(id); };
    let busy = false;
    const finish = () => {
      showArt(thanksArt, artPlan.thanks);
      root.dataset.state = 'thanks'; helper.hidden = true; choices.hidden = true;
      thanks.hidden = false; reset.hidden = false;
      status.textContent = 'これからもAttendMeと花冠あむるをよろしくね！';
      reset.focus({preventScroll:true});
    };
    const scene = (beat, text) => {
      if (beat === 'welcome' || beat === 'claim') showArt(stageArt, artPlan.welcome);
      if (beat === 'finale' || beat === 'tease') showArt(stageArt, artPlan.finale);
      root.dataset.beat = beat; speech.textContent = text; status.textContent = text;
      if (beat === 'red' || beat === 'white') q(`.amuru-love-party-${beat} .amuru-love-cheer`).textContent = text;
    };
    const celebrate = route => {
      root.dataset.route = route;
      root.dataset.state = 'celebrate'; helper.hidden = true;
      if (route === 'direct') {
        scene('welcome', pick('welcome'));
        later(() => scene('song', '蝶～♪'), 2000);
        later(() => scene('finale', pick('finale')), 4000);
      } else {
        scene('claim', pick('claim'));
        later(() => scene('red', pick('red')), 1500);
        later(() => scene('white', pick('white')), 2700);
        later(() => scene('tease', pick('tease')), 3800);
      }
      later(finish, 5000);
    };
    like.addEventListener('click', () => {
      // The mascot uses this same visual-only action; nothing is submitted or counted.
      if (busy && root.dataset.state !== 'pressing') return;
      const route = root.dataset.state === 'pressing' ? 'assisted' : 'direct';
      warmArt();
      busy = true; like.disabled = true; dislike.disabled = true; celebrate(route);
    });
    dislike.addEventListener('click', () => {
      if (busy) return;
      busy = true; dislike.disabled = true; like.disabled = true;
      warmArt(); showArt(helperArt, artPlan.helper);
      root.dataset.state = 'arriving'; helper.hidden = false;
      helperSpeech.textContent = pick('arriving');
      status.textContent = helperSpeech.textContent;
      later(() => {
        const button = like.getBoundingClientRect();
        const helperBox = helper.getBoundingClientRect();
        root.style.setProperty('--amuru-love-travel', `${button.left + button.width * .67 - (helperBox.left + helperBox.width * .5)}px`);
        root.dataset.state = 'moving';
        helperSpeech.textContent = pick('moving');
        status.textContent = helperSpeech.textContent;
        later(() => {
          root.dataset.state = 'pressing'; tap.textContent = pick('tap');
          status.textContent = `あむるが「好き」を${tap.textContent}`;
          later(() => { like.disabled = false; like.click(); }, reducedMotion.matches ? 250 : 650);
        }, reducedMotion.matches ? 150 : 1100);
      }, reducedMotion.matches ? 200 : 1000);
    });
    reset.addEventListener('click', () => {
      timers.forEach(clearTimeout); timers.clear(); busy = false;
      root.dataset.state = 'idle'; root.style.removeProperty('--amuru-love-travel');
      delete root.dataset.route; delete root.dataset.beat; speech.textContent = '';
      prepareArt(); warmArt();
      helper.hidden = true; thanks.hidden = true; reset.hidden = true; choices.hidden = false;
      like.disabled = false; dislike.disabled = false;
      status.textContent = 'あなたの「好き」、待ってます♡'; like.focus({preventScroll:true});
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { timers.forEach(clearTimeout); timers.clear(); }
    });
  };
  const initConnect = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const button = root.querySelector('[data-love-copy]');
    const text = root.querySelector('[data-love-copy-text]');
    const status = root.querySelector('[data-love-copy-status]');
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(text.value.trim());
        text.hidden = true;
        status.textContent = 'コピーしたよ♡ 感想を添えて共有してね！';
      } catch {
        text.hidden = false; text.focus(); text.select();
        status.textContent = 'この文面をコピーして、感想を添えて共有してね♡';
      }
    });
  };
  document.querySelectorAll('[data-amuru-love]').forEach(init);
  document.querySelectorAll('[data-love-connect]').forEach(initConnect);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-amuru-love]').forEach(init);
    event.target.querySelectorAll('[data-love-connect]').forEach(initConnect);
  });
})();
